import { SettingRepository } from '../repositories'

export interface GetItemListByCategoryParamsBo extends SettingRepository.GetItemListByCategoryReqDto {}

export interface GetItemListByCategoryRespBo extends SettingRepository.GetItemListByCategoryRespDto {}

/** 取得設定項目清單 */
export async function getItemListByCategory(params: GetItemListByCategoryParamsBo): Promise<GetItemListByCategoryRespBo> {
  const itemListDto = await SettingRepository.getItemListByCategory(params)

  return itemListDto
}

export interface AddItemByCategoryParamsBo extends SettingRepository.AddItemByCategoryReqDto {}

/** 新增設定項目 */
export async function addItemByCategory(params: AddItemByCategoryParamsBo) {
  await SettingRepository.addItemByCategory(params)
}

export interface GetItemByCategoryParamsBo extends SettingRepository.GetItemByCategoryReqDto {}

export type GetItemByCategoryRespBo = SettingRepository.GetItemByCategoryRespDto

/** 取得設定項目 */
export async function getItemByCategroy(params: GetItemByCategoryParamsBo): Promise<GetItemByCategoryRespBo> {
  const itemDto = await SettingRepository.getItemByCategroy(params)

  return itemDto
}

export interface DeleteItemByCategoryParamsDto extends SettingRepository.DeleteItemByCategoryReqDto {}

/** 刪除設定項目 */
export async function deleteItemByCategroy(params: DeleteItemByCategoryParamsDto) {
  await SettingRepository.deleteItemByCategroy(params)
}

export interface UpdateItemByCategoryParamsDto extends SettingRepository.UpdateItemByCategoryReqDto {}

/** 更新設定項目 */
export async function updateItemByCategroy(params: UpdateItemByCategoryParamsDto) {
  await SettingRepository.updateItemByCategroy(params)
}
